export const infoSalespersonUpdateSuccess = 'Successfully updated ';
export const namePlaceholder = 'Your name...';
export const nameLabel = 'name';
export const emailPlaceholder = 'Your email...';
export const emailLabel = 'email';
export const phoneNumberPlaceholder = 'Your phone number...';
export const phoneNumberLabel = 'phone number';
